<template>
    <button @click = "$emit('click')" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-400 hover:bg-red-300 focus:outline-none focus:border-red-400 focus:shadow-outline-red active:bg-red-400 transition ease-in-out duration-150">
        <font-awesome-icon v-if = 'icon' :icon = 'icon'  class = 'fa-fw nav-icon mr-1'></font-awesome-icon>
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "BaseButtonDanger",
        props: ['icon'],
    }
</script>